import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function BotInfoPanel() {
  const navigate = useNavigate();
  const [botInfo, setBotInfo] = useState(null);

  useEffect(() => {
    axios.get('/api/telegram/info', { withCredentials: true })
      .then(response => setBotInfo(response.data))
      .catch(() => {});
  }, []);

  return (
    <div className="conv-dashboard-section">
      <div className="conv-dashboard-section-header">
        <h4 className="conv-dashboard-section-title">Бот</h4>
        <span className="conv-dashboard-link" onClick={() => navigate('/conversations-bot-health')}>
          Діагностика та помилки →
        </span>
      </div>
      {!botInfo ? (
        <p className="conv-dashboard-empty">Завантаження...</p>
      ) : (
        <div className="bot-info-row">
          <div className="bot-info-identity">
            <span className="bot-info-username">@{botInfo.botUsername}</span>
            <span className="bot-info-path">webhook: {botInfo.webhookPath}</span>
          </div>
          <div className="bot-info-commands">
            {(botInfo.commands || []).map(command => (
              <div className="bot-info-command" key={command.command}>
                <span className="bot-info-command-name">{command.command}</span>
                <span className="bot-info-command-desc">{command.description}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
